import { UseInfiniteQueryResult } from 'react-query';
import { ReviewsTypes } from '@frontend/api-reviews';
import { InfinitePaginatedList } from '@frontend/components';
import { ReviewItemSkeletonLoader, ReviewListItem } from './reviews-page';

const MOCK_REVIEWS_LIST: UseInfiniteQueryResult<
  {
    rows: ReviewsTypes.ReviewAggregator[];
  },
  unknown
> = {
  data: {
    pages: [
      {
        rows: [
          {
            site: 'GOOGLE',
            locationId: 'loc-123',
            author: 'John Doe',
            review: 'Great experience! Very professional staff and excellent service.',
            rating: 5,
            datePublished: '2023-08-10T14:30:00Z',
            recommendationType: '',
            canReply: true,
            comments: [
              {
                commentId: 'comment-1',
                commentText: 'Thank you for your feedback!',
                commenter: 'Business Owner',
                canReply: false,
                canEdit: true,
                canDelete: true,
                comments: [],
                datePublished: '2023-08-11T09:15:00Z',
                hasRead: true,
                profileImageUrl: 'https://example.com/profile.jpg',
                dateModified: '2023-08-11T09:15:00Z',
              },
            ],
            id: 'review-1',
            hasRead: true,
            profileImageUrl: 'https://example.com/john.jpg',
            hasReplied: true,
            dateModified: '2023-08-10T14:30:00Z',
          },
          {
            site: 'FACEBOOK',
            locationId: 'loc-123',
            author: 'Jane Smith',
            review: 'Decent service, but room for improvement on appointment scheduling.',
            rating: 4,
            datePublished: '2023-07-28T10:45:00Z',
            recommendationType: 'positive',
            canReply: true,
            comments: [],
            id: 'review-2',
            hasRead: false,
            profileImageUrl: 'https://example.com/jane.jpg',
            hasReplied: false,
            dateModified: '2023-07-28T10:45:00Z',
          },
          {
            site: 'PRIVATE',
            locationId: 'loc-456',
            author: 'Mike Johnson',
            review: 'Not satisfied with the results. Communication could be better.',
            rating: 2,
            datePublished: '2023-07-15T16:20:00Z',
            recommendationType: 'negative',
            canReply: true,
            comments: [],
            id: 'review-3',
            hasRead: true,
            profileImageUrl: 'https://example.com/mike.jpg',
            hasReplied: false,
            dateModified: '2023-07-15T16:20:00Z',
          },
          {
            site: 'YELP',
            locationId: 'loc-123',
            author: 'Sarah Williams',
            review: 'Absolutely fantastic! Would highly recommend to anyone looking for quality service.',
            rating: 5,
            datePublished: '2023-08-05T11:25:00Z',
            recommendationType: 'positive',
            canReply: true,
            comments: [
              {
                commentId: 'comment-2',
                commentText: 'We appreciate your kind words, Sarah! Hope to see you again soon.',
                commenter: 'Business Owner',
                canReply: false,
                canEdit: true,
                canDelete: true,
                comments: [],
                datePublished: '2023-08-06T08:30:00Z',
                hasRead: true,
                profileImageUrl: 'https://example.com/profile.jpg',
                dateModified: '2023-08-06T08:30:00Z',
              },
            ],
            id: 'review-4',
            hasRead: true,
            profileImageUrl: 'https://example.com/sarah.jpg',
            hasReplied: true,
            dateModified: '2023-08-05T11:25:00Z',
          },
          {
            site: 'GOOGLE',
            locationId: 'loc-456',
            author: 'Robert Chen',
            review: 'Average experience. Staff was friendly but the wait time was longer than expected.',
            rating: 3,
            datePublished: '2023-07-30T15:40:00Z',
            recommendationType: 'neutral',
            canReply: true,
            comments: [],
            id: 'review-5',
            hasRead: false,
            profileImageUrl: 'https://example.com/robert.jpg',
            hasReplied: false,
            dateModified: '2023-07-30T15:40:00Z',
          },
          {
            site: 'FACEBOOK',
            locationId: 'loc-456',
            author: 'Emily Taylor',
            review: 'Disappointed with my experience. The product quality was not what I expected based on reviews.',
            rating: 2,
            datePublished: '2023-07-22T09:15:00Z',
            recommendationType: 'negative',
            canReply: true,
            comments: [
              {
                commentId: 'comment-3',
                commentText:
                  "We're sorry to hear about your experience, Emily. Please contact our customer service so we can make things right.",
                commenter: 'Business Owner',
                canReply: false,
                canEdit: true,
                canDelete: true,
                comments: [],
                datePublished: '2023-07-23T10:45:00Z',
                hasRead: true,
                profileImageUrl: 'https://example.com/profile.jpg',
                dateModified: '2023-07-23T10:45:00Z',
              },
            ],
            id: 'review-6',
            hasRead: true,
            profileImageUrl: 'https://example.com/emily.jpg',
            hasReplied: true,
            dateModified: '2023-07-22T09:15:00Z',
          },
          {
            site: 'TRIPADVISOR',
            locationId: 'loc-789',
            author: 'David Garcia',
            review:
              'Wonderful place! Great attention to detail and the staff really went out of their way to make our visit special.',
            rating: 5,
            datePublished: '2023-08-01T13:50:00Z',
            recommendationType: 'positive',
            canReply: true,
            comments: [],
            id: 'review-7',
            hasRead: false,
            profileImageUrl: 'https://example.com/david.jpg',
            hasReplied: false,
            dateModified: '2023-08-01T13:50:00Z',
          },
        ],
      },
    ],
    pageParams: [undefined],
  },
  isLoading: false,
  isFetching: false,
  isError: false,
  isSuccess: true,
  isIdle: false,
  isLoadingError: false,
  isRefetchError: false,
  dataUpdatedAt: new Date().getTime(),
  errorUpdatedAt: 0,
  failureCount: 0,
  errorUpdateCount: 0,
  isFetched: true,
  isFetchedAfterMount: true,
  isPlaceholderData: false,
  isPreviousData: false,
  error: null,
  fetchNextPage: () => Promise.reject(),
  fetchPreviousPage: () => Promise.reject(),
  hasNextPage: false,
  hasPreviousPage: false,
  isFetchingNextPage: false,
  isFetchingPreviousPage: false,
  status: 'success',
  refetch: () => Promise.resolve({} as any),
  isStale: false,
  isRefetching: false,
  remove: () => {},
};

export const NoAccessReviewsList = () => {
  return (
    <>
      <InfinitePaginatedList
        skeletonLoader={<ReviewItemSkeletonLoader />}
        infiniteQueryProps={MOCK_REVIEWS_LIST}
        renderListItem={ReviewListItem}
        css={{
          position: 'relative',
        }}
      />
      <div
        css={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'all',
          backdropFilter: 'blur(3px)',
        }}
      />
    </>
  );
};
